import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lang" }
const _hoisted_2 = {
  key: 1,
  class: "lang-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Flag = _resolveComponent("Flag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.flag)
      ? (_openBlock(), _createBlock(_component_Flag, {
          key: 0,
          class: "lang-flag",
          code: _ctx.flag
        }, null, 8, ["code"]))
      : _createCommentVNode("", true),
    (_ctx.full)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.countryFull), 1))
      : _createCommentVNode("", true)
  ]))
}